export default __webpack_public_path__ + "static/media/package.2aa07de3.jpg";